namespace GeniuzPOS.Product {
    export class CsSubCategory1Columns {
        static columnsKey = 'Product.CsSubCategory1';
    }
}
